var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 4.38077C14.9176 4.38077 17.1562 6.61937 17.1562 9.38075C17.1562 12.1422 14.9176 14.3808 12.1562 14.3808C9.39478 14.3808 7.15621 12.1422 7.15621 9.38075C7.15621 6.61937 9.39478 4.38077 12.1562 4.38077ZM12.1562 6.25575C10.4304 6.25575 9.03121 7.65487 9.03121 9.38075C9.03121 11.1066 10.4304 12.5057 12.1562 12.5057C13.8821 12.5057 15.2812 11.1066 15.2812 9.38075C15.2812 7.65487 13.8821 6.25575 12.1562 6.25575ZM12.1562 0C17.9231 0 22.9014 3.93751 24.2826 9.4555C24.4084 9.95775 24.1031 10.4669 23.6009 10.5926C23.0985 10.7183 22.5895 10.4131 22.4637 9.91075C21.2901 5.22245 17.0579 1.875 12.1562 1.875C7.25238 1.875 3.01883 5.22532 1.84728 9.9165C1.72183 10.4187 1.21291 10.7243 0.710568 10.5989C0.208231 10.4734 -0.0972941 9.9645 0.0281558 9.46213C1.40702 3.9409 6.38682 0 12.1562 0Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.b645df9e4c10bf5315c2cc9cf553e168.svg";
export { ForwardRef as ReactComponent };